import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import DataTable from "react-data-table-component";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import Popup from "../common/popup";
import moment from "moment";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";

const Holiday = () => {
  const { t } = useTranslation();
  const [searchTextVal, setSearchTextVal] = useState("");
  const [holidaylist, setHolidaylist] = useState([]);
  const [templist, setTemplist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [popupView, setPopupView] = useState("");
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [holidayvalue, setHolidayvalue] = useState("");

  useEffect(() => {
    if (!sessionStorage.getItem("isLoggedIn")) {
      window.location.href = "/";
      return;
    }
    const authData = JSON.parse(sessionStorage.getItem("authData"));
    if (
      authData !== "" &&
      !authData.adminRole.permissions.includes("manage_settings")
    ) {
      window.location.href = "/unauthorized";
      return;
    }
    getHolidaylist();
  }, []);

  const getHolidaylist = () => {
    const URL = BaseUrl + "admin/holidays";
    http
      .get(URL)
      .then((response) => {
        const sortedData = response.data.data.sort(
          (a, b) => new Date(b.holidayDate) - new Date(a.holidayDate),
        );
        setHolidaylist(sortedData);
        setTemplist(sortedData);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const viewHolidayDetails = (holiday) => {
    const popupResult = (
      <Popup
        extClass="order-pop title-left pop-container-sm"
        headMoreTxt={
          <>
            <div className="order-top">
              <div className="head">
                <h4>{t("holiday_details_txt")}</h4>
              </div>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
            <div className="order-top">
              <div className="bottom vendor-details holidaydetails">
                <p>
                  <span className="labeltxt">{t("title_txt")}</span>:{" "}
                  {holiday.holidayTitle}
                </p>
                <p>
                  <span className="labeltxt">{t("date_txt")}</span>:{" "}
                  {moment(holiday.holidayDate).format("DD-MM-YYYY")}
                </p>
              </div>
            </div>
          </>
        }
        closebtn={
          <>
            <span onClick={() => setPopupView("")} className="close"></span>
          </>
        }
      />
    );
    setPopupView(popupResult);
  };

  const deleteHoliday = (value) => {
    setVisibleAlert(true);
    setHolidayvalue(value);
  };

  const deleteHolidayValue = () => {
    const URL = BaseUrl + `admin/holidays/${holidayvalue._id}`;
    http
      .delete(URL)
      .then((response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const alertPopupclose = () => {
    setVisibleAlert(false);
    setHolidayvalue("");
  };

  const addholiday = () => {
    window.location.href = "/holiday/add/";
  };

  const handleReset = () => {
    setSearchTextVal("");
    setHolidaylist(templist);
  };

  const handleChange = (value) => {
    setSearchTextVal(value);
    filterData(value);
  };

  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue.length > 0) {
      const result = templist.filter((item) =>
        item.holidayTitle.toString().toLowerCase().includes(lowercasedValue),
      );

      setHolidaylist(result);
    } else {
      setHolidaylist(templist);
    }
  };

  const columns = [
    {
      name: t("title_txt"),
      selector: (row) => row.holidayTitle,
      sortable: true,
    },
    {
      name: t("date_txt"),
      selector: (row) => moment(row.holidayDate).format("DD-MM-YYYY"),
      sortable: true,
    },
    {
      name: t("actions_txt"),
      selector: (row) => (
        <div style={{ display: "flex" }}>
          {canAction("manage_settings", "view") && (
            <a
              className="button title-tooltip title-up"
              data-title={t("view_txt")}
              style={{ color: "white" }}
              onClick={() => viewHolidayDetails(row)}
            >
              <i className="fa fa-eye" aria-hidden="true"></i>
            </a>
          )}
          {canAction("manage_settings", "delete") && (
            <a
              className="button title-tooltip title-up"
              data-title={t("delete_txt")}
              style={{ color: "white" }}
              onClick={() => deleteHoliday(row)}
            >
              <i className="fa fa-trash" aria-hidden="true"></i>
            </a>
          )}
        </div>
      ),
      sortable: false,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <>
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">{t("holiday_settings_txt")}</h1>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("search_txt")}
                      />
                    </div>
                    <button
                      className="submitbtn button search-holi-btn"
                      onClick={() => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                    <button
                      className="resetbtn"
                      type="reset"
                      onClick={handleReset}
                    >
                      {t("reset_txt")}
                    </button>
                  </div>
                  {canAction("manage_settings", "add") && (
                    <div className="add-holidaybtn">
                      <button className="addbtn" onClick={addholiday}>
                        {t("add_txt")}
                      </button>
                    </div>
                  )}
                </div>
                <div className="table_overflow">
                  <DataTable
                    columns={columns}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_matching_holiday_txt")}
                      </div>
                    }
                    data={holidaylist}
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={paginationComponentOptions}
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
      {popupView}
      {visibleAlert && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("confirm_delete_txt")}</p>
                <div className="alert-buttons">
                  <a
                    title={t("ok_txt")}
                    onClick={deleteHolidayValue}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    title={t("cancel_txt")}
                    onClick={alertPopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Holiday;